export const EMAIL_FEATURES = {
  moduleKey: 'email',
  features: ['email.send', 'email.templates'] as const,
  featureMeta: {
    'email.send': {
      name: 'Send email',
      translations: { name: { de: 'E-Mails senden', en: 'Send email', fr: 'Envoyer des e-mails', it: 'Inviare e-mail' } },
    },
    'email.templates': {
      name: 'Email templates',
      translations: { name: { de: 'E-Mail-Vorlagen', en: 'Email templates', fr: "Modèles d'e-mails", it: 'Modelli e-mail' } },
    },
  },
} as const;
